import { useState, useEffect } from "react";

export interface CMSContent {
  heroTitle: string;
  heroSubtitle: string;
  heroDescription: string;
  aboutTitle: string;
  aboutDescription: string;
  missionStatement: string;
  contactEmail: string;
  contactPhone: string;
  contactAddress: string;
  footerText: string;
  socialFacebook: string;
  socialTwitter: string;
  socialYoutube: string;
}

export const defaultCMSContent: CMSContent = {
  heroTitle: "",
  heroSubtitle: "",
  heroDescription: "",
  aboutTitle: "",
  aboutDescription: "",
  missionStatement: "",
  contactEmail: "",
  contactPhone: "",
  contactAddress: "",
  footerText: "",
  socialFacebook: "",
  socialTwitter: "",
  socialYoutube: "",
};

const CMS_CONTENT_KEY = "cms_content_v2";

export function useCMSContent() {
  const [content, setContent] = useState<CMSContent>(() => {
    const saved = localStorage.getItem(CMS_CONTENT_KEY);
    return saved
      ? { ...defaultCMSContent, ...JSON.parse(saved) }
      : defaultCMSContent;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const saved = localStorage.getItem(CMS_CONTENT_KEY);
      setContent(
        saved
          ? { ...defaultCMSContent, ...JSON.parse(saved) }
          : defaultCMSContent
      );
    };

    window.addEventListener("storage", handleStorageChange);

    // Also listen to custom event for same-window updates
    window.addEventListener("cms-content-updated", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("cms-content-updated", handleStorageChange);
    };
  }, []);

  return content;
}

export function saveCMSContent(content: CMSContent) {
  localStorage.setItem(CMS_CONTENT_KEY, JSON.stringify(content));
  window.dispatchEvent(new Event("cms-content-updated"));
}
